<template>
	<div>
		<div
			v-if="!mobile"
			:class="$style.col"
		>
			<a-button-group :class="[mobile ? $style.buttonMobile : null]">
				<a-tooltip placement="top">
					<template slot="title">
						<span>
							<fa-icon
								:icon="['far', 'edit']"
								class="mr-2"
							/>Editar
						</span>
					</template>
					<a-button
						v-if="$gestios.items(app).auth({
							scopes: [`set.mine`, `set`],
							strict: false,
							item
						})"
						@click="$emit('edit', item)"
					>
						<fa-icon
							:icon="['far', 'edit']"
						/>
					</a-button>
				</a-tooltip>

				<a-popconfirm
					v-if="$gestios.items(app).auth({
						scopes: [`del.mine`, `del`],
						strict: false,
						item
					})"
					title="¿Estas seguro que deseas borrar este elemento?"
					@confirm="() => $parent.deleteItems([item])"
				>
					<a-tooltip placement="top">
						<template slot="title">
							<span>
								<fa-icon
									:icon="['far', 'trash-alt']"
									class="mr-2"
								/> Eliminar
							</span>
						</template>
						<a-button type="danger">
							<fa-icon
								:icon="['far', 'trash-alt']"
							/>
						</a-button>
					</a-tooltip>
				</a-popconfirm>
			</a-button-group>
		</div>
		<div v-else>
			<div class="row">
				<div class="col-6">
					<a-button
						v-if="$gestios.items(app).auth({
							scopes: [`set.mine`, `set`],
							strict: false,
							item
						})"
						block
						ghost
						@click="$emit('edit', item)"
					>
						<fa-icon
							:icon="['far', 'edit']"
							class="mr-2"
						/> Editar
					</a-button>
				</div>
				<div class="col-6">
					<a-popconfirm
						v-if="$gestios.items(app).auth({
							scopes: [`del.mine`, `del`],
							strict: false,
							item
						})"
						title="¿Estas seguro que deseas borrar este elemento?"
						@confirm="() => $parent.deleteItems([item])"
					>
						<a-button
							type="danger"
							block
						>
							<fa-icon
								:icon="['far', 'trash-alt']"
								class="mr-2"
							/> Eliminar
						</a-button>
					</a-popconfirm>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'GTableSlotAction',
	props: {
		item: {
			type: Object,
			required: true
		},
		app: {
			type: String,
			required: true
		},
		mobile: {
			type: Boolean,
			default: false
		}
	}
};
</script>

<style lang="scss" module>
.col{
	text-align: right;
	min-width: 100px;
}

.buttonMobile{
	width: 100%;

	button{
		width: 50%;
	}
}

</style>
